import React from 'react';
import { PageHero, SectionTitle, Input, Textarea, Card } from '../components/PageUI';

const EspecialistaPage = () => {
  const reasons = [
    'Projetos com múltiplas filiais',
    'Integrações com sistemas legados',
    'Necessidade de BI avançado',
    'Operações com entrega e roteirização'
  ];

  return (
    <div>
      <PageHero
        eyebrow="Fale com especialista"
        title="Receba um diagnóstico consultivo."
        subtitle="Descubra quais módulos e integrações geram maior impacto para seu negócio."
        primaryCta={{ label: 'Chamar no WhatsApp', href: 'https://wa.me/5511975592019' }}
      />

      <section className="bg-slate-950">
        <div className="container mx-auto px-8 lg:px-12 py-16">
          <SectionTitle
            eyebrow="Quando falar"
            title="Situações ideais para consultoria"
            description="Conte para nossa equipe o que você precisa resolver."
          />
          <div className="grid md:grid-cols-2 gap-6">
            <Card>
              <ul className="space-y-2 text-sm text-slate-200/80">
                {reasons.map((item) => (
                  <li key={item} className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-[#FF6B35]" />
                    {item}
                  </li>
                ))}
              </ul>
            </Card>
            <Card>
              <form className="space-y-3">
                <Input label="Nome completo" placeholder="Digite seu nome" />
                <Input label="E-mail" type="email" placeholder="voce@empresa.com" />
                <Input label="Telefone" placeholder="(11) 99999-9999" />
                <Textarea label="Mensagem" rows={4} placeholder="Explique sua necessidade" />
                <button type="submit" className="w-full px-6 py-3 rounded-xl font-black text-lg bg-[#FF6B35] text-white">
                  Enviar
                </button>
              </form>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EspecialistaPage;
